import { DomainMessagesTypes } from 'shared/domain/messages/message';
import * as dbProjects from '../../db/projects/projects';
import * as dbProjectsService from '../../db/projects/projectsService';
import { projectEntityToModel } from 'shared/domain/project/mapping/toModel';
import { ProjectModel } from 'shared/domain/project/types/model';
import { swSignals } from 'serviceWorker/events/swSignals';
import { projectContract } from 'shared/domain/project/projectContract';
import { makeLoadedEventPublisher, readCollectionPayload } from 'serviceWorker/broadcasts/publishers';

/** Every project of IndexedDB as a model, archived ones included. */
export async function readProjectModels(): Promise<ProjectModel[]> {
  const projectEntities = await dbProjects.get();
  return projectEntities.map(projectEntityToModel);
}

const broadcastAllProjectModels = makeLoadedEventPublisher(
  projectContract,
  DomainMessagesTypes.allProjects,
  () => readCollectionPayload(dbProjectsService, readProjectModels)
);

export const broadcastAllProjects = async (): Promise<void> => {
  const status = await dbProjectsService.get();
  await broadcastAllProjectModels();

  // Only a complete list resyncs the selected project: resyncing on an
  // incomplete one (hasAll: false) retriggers getProjects → the project list
  // download in a loop.
  if (status?.isDownloaded) {
    swSignals.projectListStored.emit();
  }
};
